import React, { useContext } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';
import { ProductsContext } from '../../../contexts/ProductsContext';
import { InvoiceContext } from '../../../contexts/InvoiceContext';
import { formatCurrency } from '../../../utils/formatters';

const InvoiceProductSelector = ({ selectedProduct, onChange, index }) => {
    const { t } = useTranslation();
    const { products } = useContext(ProductsContext);
    const { invoice } = useContext(InvoiceContext);

    // Filter products that are suitable for invoice items
    const invoiceableProducts = products.filter(p => p.invoice_item);
    
    // Handle focus event - simply scroll the element into view
    const handleInputFocus = (event) => {
        setTimeout(() => {
            event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel>{t(StringKeys.PRODUCT)}</InputLabel>
            <Select
                value={selectedProduct?.id || ''}
                label={t(StringKeys.PRODUCT)}
                onChange={(e) => {
                    const selectedProduct = invoiceableProducts.find(p => p.id === e.target.value);
                    onChange(selectedProduct);
                }}
                sx={{ minWidth: '180px' }}
                onFocus={handleInputFocus}
            >
                <MenuItem value="">
                    <em>{t(StringKeys.NONE)}</em>
                </MenuItem>
                {invoiceableProducts.map((product) => (
                    <MenuItem key={product.id} value={product.id}>
                        {product.name} {product.price ? `- ${formatCurrency(product.price)}` : 
                         product.default_price?.unit_amount ? `- ${formatCurrency(product.default_price.unit_amount / 100)}` : ''}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default InvoiceProductSelector; 